import { create } from "zustand";

export type DemoOpenPhase = "idle" | "cover" | "exit";

export interface DemoOpenState {
  phase: DemoOpenPhase;
  mounted: boolean;
  start: () => void;
  beginExit: () => void;
  finish: () => void;
  cancel: () => void;
}

export const useDemoOpenStore = create<DemoOpenState>((set) => ({
  phase: "idle",
  mounted: false,
  start: () => set({ mounted: true, phase: "cover" }),
  beginExit: () => set({ phase: "exit" }),
  finish: () => set({ mounted: false, phase: "idle" }),
  cancel: () => set({ mounted: false, phase: "idle" }),
}));
